module.exports = __webpack_public_path__ + "static/media/markalar_listeleme_logo_3.105ff649.png";